import { ArticleFooter } from '@/components/ArticleFooter';
import { LabradorComponent } from '@/types/component';

export const LabradorArticleFooter: LabradorComponent = ({ type, data, meta, descendants, ...props }) => {
  return <ArticleFooter tags={data.tags} options={data.options} {...props} />;
};
